import { useInstantSearch } from 'react-instantsearch'
import type { OperationVariables } from '@apollo/client'

import { TaggingContext, TaggingTableSelectionContext } from './TaggingContexts'
import type { TaggingEntityAdapter } from './taggingEntityAdapter.types'
import type { TaggingProviderProps } from './TaggingProvider.types'
import { useTaggingTable } from './useTaggingTable'

interface EntityTaggingProviderProps<
  TAddData,
  TAddVariables extends OperationVariables,
  TRemoveData,
  TRemoveVariables extends OperationVariables,
> extends TaggingProviderProps {
  adapter: TaggingEntityAdapter<
    TAddData,
    TAddVariables,
    TRemoveData,
    TRemoveVariables
  >
}

export const EntityTaggingProvider = <
  TAddData,
  TAddVariables extends OperationVariables,
  TRemoveData,
  TRemoveVariables extends OperationVariables,
>(
  props: EntityTaggingProviderProps<
    TAddData,
    TAddVariables,
    TRemoveData,
    TRemoveVariables
  >,
) => {
  const { adapter, children, hits } = props
  const { refresh } = useInstantSearch()
  const hook = useTaggingTable({ adapter, hits, refresh })
  const {
    isRowSelected,
    rowSelection,
    selectedCount,
    selectedRowIds,
    setRowSelection,
    ...tagging
  } = hook
  const selection = {
    isRowSelected,
    rowSelection,
    selectedCount,
    selectedRowIds,
    setRowSelection,
  }

  return (
    <TaggingContext.Provider value={tagging}>
      <TaggingTableSelectionContext.Provider value={selection}>
        {children}
      </TaggingTableSelectionContext.Provider>
    </TaggingContext.Provider>
  )
}
